import React from 'react';
import Layout from '../components/layout/Layout';
import { companyInfo } from '../data/mock';

const TermsPage = () => {
  return (
    <Layout>
      <section className="bg-white py-16">
        <div className="container-main">
          <h1 className="text-4xl md:text-5xl font-bold text-navy font-display mb-8">Terms of Service</h1>
          
          <div className="max-w-3xl prose prose-lg text-gray-600">
            <p className="text-sm text-gray-500 mb-8">Last updated: August 2025</p>
            
            <h2 className="text-2xl font-bold text-navy mt-8 mb-4">1. Agreement to Terms</h2>
            <p className="mb-4 leading-relaxed">
              By accessing or using the services provided by {companyInfo.name}, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8 mb-4">2. Services</h2>
            <p className="mb-4 leading-relaxed">
              {companyInfo.name} provides digital design and development services including but not limited to UI/UX design, web development, mobile app design, branding, and related consulting services.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8 mb-4">3. Intellectual Property</h2>
            <p className="mb-4 leading-relaxed">
              All content, designs, and materials created by {companyInfo.name} remain our intellectual property until full payment is received. Upon completion of payment, ownership of deliverables transfers to the client as specified in the project agreement.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8 mb-4">4. Payment Terms</h2>
            <p className="mb-4 leading-relaxed">
              Payment terms are outlined in individual project proposals. Generally, we require a deposit before commencing work, with the balance due upon project completion or according to the agreed milestone schedule.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8 mb-4">5. Confidentiality</h2>
            <p className="mb-4 leading-relaxed">
              We maintain strict confidentiality regarding all client information and project details. We will not disclose any proprietary information to third parties without explicit consent.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8 mb-4">6. Limitation of Liability</h2>
            <p className="mb-4 leading-relaxed">
              {companyInfo.name} shall not be liable for any indirect, incidental, special, or consequential damages arising from the use of our services. Our total liability is limited to the amount paid for the specific service in question.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8 mb-4">7. Contact Information</h2>
            <p className="mb-4 leading-relaxed">
              For questions about these Terms of Service, please contact us at:
            </p>
            <p className="mb-2">{companyInfo.name}</p>
            <p className="mb-2">{companyInfo.address}</p>
            <p className="mb-2">Email: {companyInfo.email}</p>
            <p className="mb-2">Phone: {companyInfo.phone}</p>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default TermsPage;
